/**
 * Shared constants — domain enumerations used by both the Worker API
 * and the mobile/web client.
 */

export const EXPENSE_CATEGORIES = [
  'Feed',
  'Hay',
  'School Supplies',
  'Infrastructure',
  'Other',
] as const

export type ExpenseCategory = (typeof EXPENSE_CATEGORIES)[number]

// ---------------------------------------------------------------------------
// Sessions
// ---------------------------------------------------------------------------

/** Individual session identifiers (used on Attendance records). */
export const SESSIONS = ['mon_wed', 'tue_thu'] as const
export type Session = (typeof SESSIONS)[number]

/** Human-readable labels for each session. */
export const SESSION_LABELS: Record<Session, string> = {
  mon_wed: 'Mon / Wed',
  tue_thu: 'Tue / Thu',
}

/** Options when assigning a student to session(s) — includes "both". */
export const SESSION_OPTIONS = ['mon_wed', 'tue_thu', 'both'] as const
export type SessionOption = (typeof SESSION_OPTIONS)[number]

// ---------------------------------------------------------------------------
// Enrollment statuses
// ---------------------------------------------------------------------------

export const ENROLLMENT_STATUSES = ['enrolled', 'inactive'] as const
export type EnrollmentStatus = (typeof ENROLLMENT_STATUSES)[number]

/**
 * @deprecated Use EnrollmentStatus instead — status now lives on the
 * Enrollment record, not the Student record. Waitlist is now a standalone table.
 */
export const STUDENT_STATUSES = ['waitlist', 'enrolled', 'inactive'] as const
/** @deprecated Use EnrollmentStatus instead. */
export type StudentStatus = (typeof STUDENT_STATUSES)[number]
